import { defineMessages } from 'react-intl';

export default defineMessages({
  linkActionButtonLabel: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.linkActionButtonLabel',
    description: 'Link Jira project button label.',
    defaultMessage: 'Link project',
  },
  siteSelectorPlaceholder: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.siteSelectorPlaceholder',
    description: 'Site selector placeholder on manage projects screen.',
    defaultMessage: 'Select a site',
  },
  siteSelectorFailedMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.siteSelectorFailedMessage',
    description: 'Site selector failed message on manage projects screen.',
    defaultMessage: 'Failed to load sites',
  },
  siteSelectorNoSitesMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.siteSelectorNoSitesMessage',
    description: 'Site selector - No sites on manage projects screen.',
    defaultMessage: 'No sites',
  },
  projectSelectorPlaceholder: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.projectSelectorPlaceholder',
    description: 'Project selector placeholder on manage projects screen.',
    defaultMessage: 'Select a project',
  },
  projectSelectorFailedMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.projectSelectorFailedMessage',
    description: 'project selector failed message on manage projects screen.',
    defaultMessage: 'Failed to load projects',
  },
  projectSelectorNoProjectsMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.projectSelectorNoProjectsMessage',
    description: 'Project selector - No projects on manage projects screen.',
    defaultMessage: 'No projects',
  },
  typeToFilterProjectsMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProject.typeToFilterProjectsMessage',
    description: 'Project selector - type to filter message',
    defaultMessage: 'Type to filter...',
  },
});
